/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch.ts";
import type {
	CreateIrrigationEvent400,
	CreateIrrigationEvent500,
	CreateOnDemandIrrigationEvent201,
	CreateOnDemandIrrigationEvent400,
	CreateOnDemandIrrigationEvent500,
	DeleteIrrigationEvent400,
	DeleteIrrigationEvent404,
	DeleteIrrigationEvent409,
	DeleteIrrigationEvent500,
	DeleteIrrigationEventParams,
	GetIrrigationEvent400,
	GetIrrigationEvent404,
	GetIrrigationEvent500,
	IrrigationEventCreateRequest,
	IrrigationEventResponse,
	IrrigationEventUpdate,
	ListIrrigationEvents200,
	ListIrrigationEvents400,
	ListIrrigationEvents500,
	ListIrrigationEventsParams,
	OnDemandIrrigationEventCreateRequest,
	OnDemandIrrigationRejection,
	StopIrrigationEvent400,
	StopIrrigationEvent404,
	StopIrrigationEvent500,
	StopIrrigationRejection,
	UpdateIrrigationEvent400,
	UpdateIrrigationEvent404,
	UpdateIrrigationEvent409,
	UpdateIrrigationEvent500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getListIrrigationEventsUrl = (
	params?: ListIrrigationEventsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/irrigation-events?${stringifiedParams}`
		: `/irrigation-events`;
};

/**
 * @summary List irrigation events for the authenticated user, optionally filtered by group, set, or zone
 */
export const listIrrigationEvents = async (
	params?: ListIrrigationEventsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<ListIrrigationEvents200> => {
	return customFetch<ListIrrigationEvents200>(
		getListIrrigationEventsUrl(params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListIrrigationEventsQueryKey = (
	params?: ListIrrigationEventsParams,
) => {
	return ["irrigation-events", ...(params ? [params] : [])] as const;
};

export const getListIrrigationEventsQueryOptions = <
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params?: ListIrrigationEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListIrrigationEventsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listIrrigationEvents>>
	> = ({ signal }) =>
		listIrrigationEvents(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listIrrigationEvents>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListIrrigationEventsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listIrrigationEvents>>
>;
export type ListIrrigationEventsQueryError =
	| ListIrrigationEvents400
	| ListIrrigationEvents500;

export function useListIrrigationEvents<
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params: undefined | ListIrrigationEventsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listIrrigationEvents>>,
					TError,
					Awaited<ReturnType<typeof listIrrigationEvents>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListIrrigationEvents<
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params?: ListIrrigationEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listIrrigationEvents>>,
					TError,
					Awaited<ReturnType<typeof listIrrigationEvents>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListIrrigationEvents<
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params?: ListIrrigationEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List irrigation events for the authenticated user, optionally filtered by group, set, or zone
 */

export function useListIrrigationEvents<
	TData = Awaited<ReturnType<typeof listIrrigationEvents>>,
	TError = ListIrrigationEvents400 | ListIrrigationEvents500,
>(
	params?: ListIrrigationEventsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listIrrigationEvents>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListIrrigationEventsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List irrigation events for the authenticated user, optionally filtered by group, set, or zone
 */
export const useSetListIrrigationEventsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListIrrigationEventsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listIrrigationEvents>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listIrrigationEvents>> | undefined,
			  ) => Awaited<ReturnType<typeof listIrrigationEvents>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listIrrigationEvents>>
		>(
			{ exact: $exactMatch, queryKey: getListIrrigationEventsQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary List irrigation events for the authenticated user, optionally filtered by group, set, or zone
 */
export const useGetListIrrigationEventsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListIrrigationEventsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listIrrigationEvents>>>(
			getListIrrigationEventsQueryKey(params),
		);
};

export const getCreateIrrigationEventUrl = () => {
	return `/irrigation-events`;
};

/**
 * @summary Create a one-time irrigation event from a start time
 */
export const createIrrigationEvent = async (
	irrigationEventCreateRequest: IrrigationEventCreateRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationEventResponse> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<IrrigationEventResponse>(getCreateIrrigationEventUrl(), {
		...options,
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			...getHeaders(options?.headers),
		},
		body: JSON.stringify(irrigationEventCreateRequest),
	});
};

export const getCreateIrrigationEventMutationKey = () =>
	["createIrrigationEvent"] as const;

export const getCreateIrrigationEventMutationOptions = <
	TError = CreateIrrigationEvent400 | CreateIrrigationEvent500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createIrrigationEvent>>,
		TError,
		CreateIrrigationEventMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createIrrigationEvent>>,
	TError,
	CreateIrrigationEventMutationVariables,
	TContext
> => {
	const mutationKey = getCreateIrrigationEventMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createIrrigationEvent>>,
		CreateIrrigationEventMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return createIrrigationEvent(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateIrrigationEventMutationResult = NonNullable<
	Awaited<ReturnType<typeof createIrrigationEvent>>
>;
export type CreateIrrigationEventMutationBody = IrrigationEventCreateRequest;
export type CreateIrrigationEventMutationError =
	| CreateIrrigationEvent400
	| CreateIrrigationEvent500;
export type CreateIrrigationEventMutationVariables = {
	data: IrrigationEventCreateRequest;
};

/**
 * @summary Create a one-time irrigation event from a start time
 */
export const useCreateIrrigationEvent = <
	TError = CreateIrrigationEvent400 | CreateIrrigationEvent500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createIrrigationEvent>>,
			TError,
			CreateIrrigationEventMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createIrrigationEvent>>,
	TError,
	CreateIrrigationEventMutationVariables,
	TContext
> => {
	return useMutation(
		getCreateIrrigationEventMutationOptions(options),
		queryClient,
	);
};
export const getGetIrrigationEventUrl = (irrigationEventId: string) => {
	return `/irrigation-events/${irrigationEventId}`;
};

/**
 * @summary Get a single irrigation event by ID
 */
export const getIrrigationEvent = async (
	irrigationEventId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationEventResponse> => {
	return customFetch<IrrigationEventResponse>(
		getGetIrrigationEventUrl(irrigationEventId),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetIrrigationEventQueryKey = (irrigationEventId: string) => {
	return ["irrigation-events", irrigationEventId] as const;
};

export const getGetIrrigationEventQueryOptions = <
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetIrrigationEventQueryKey(irrigationEventId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getIrrigationEvent>>
	> = ({ signal }) =>
		getIrrigationEvent(irrigationEventId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: irrigationEventId !== null && irrigationEventId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getIrrigationEvent>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIrrigationEventQueryResult = NonNullable<
	Awaited<ReturnType<typeof getIrrigationEvent>>
>;
export type GetIrrigationEventQueryError =
	| GetIrrigationEvent400
	| GetIrrigationEvent404
	| GetIrrigationEvent500;

export function useGetIrrigationEvent<
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getIrrigationEvent>>,
					TError,
					Awaited<ReturnType<typeof getIrrigationEvent>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIrrigationEvent<
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getIrrigationEvent>>,
					TError,
					Awaited<ReturnType<typeof getIrrigationEvent>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIrrigationEvent<
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single irrigation event by ID
 */

export function useGetIrrigationEvent<
	TData = Awaited<ReturnType<typeof getIrrigationEvent>>,
	TError =
		| GetIrrigationEvent400
		| GetIrrigationEvent404
		| GetIrrigationEvent500,
>(
	irrigationEventId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getIrrigationEvent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetIrrigationEventQueryOptions(
		irrigationEventId,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a single irrigation event by ID
 */
export const useSetGetIrrigationEventQueryData = () => {
	const queryClient = useQueryClient();
	return (
		irrigationEventId: string,
		updater:
			| Awaited<ReturnType<typeof getIrrigationEvent>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getIrrigationEvent>> | undefined,
			  ) => Awaited<ReturnType<typeof getIrrigationEvent>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getIrrigationEvent>>>(
			{
				exact: $exactMatch,
				queryKey: getGetIrrigationEventQueryKey(irrigationEventId),
			},
			updater,
		);
	};
};

/**
 * @summary Get a single irrigation event by ID
 */
export const useGetGetIrrigationEventQueryData = () => {
	const queryClient = useQueryClient();
	return (irrigationEventId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getIrrigationEvent>>>(
			getGetIrrigationEventQueryKey(irrigationEventId),
		);
};

export const getUpdateIrrigationEventUrl = (irrigationEventId: string) => {
	return `/irrigation-events/${irrigationEventId}`;
};

/**
 * @summary Update an existing irrigation event
 */
export const updateIrrigationEvent = async (
	irrigationEventId: string,
	irrigationEventUpdate: IrrigationEventUpdate,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationEventResponse> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<IrrigationEventResponse>(
		getUpdateIrrigationEventUrl(irrigationEventId),
		{
			...options,
			method: "PATCH",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(irrigationEventUpdate),
		},
	);
};

export const getUpdateIrrigationEventMutationKey = () =>
	["updateIrrigationEvent"] as const;

export const getUpdateIrrigationEventMutationOptions = <
	TError =
		| UpdateIrrigationEvent400
		| UpdateIrrigationEvent404
		| UpdateIrrigationEvent409
		| UpdateIrrigationEvent500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateIrrigationEvent>>,
		TError,
		UpdateIrrigationEventMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateIrrigationEvent>>,
	TError,
	UpdateIrrigationEventMutationVariables,
	TContext
> => {
	const mutationKey = getUpdateIrrigationEventMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateIrrigationEvent>>,
		UpdateIrrigationEventMutationVariables
	> = (props) => {
		const { irrigationEventId, data } = props ?? {};

		return updateIrrigationEvent(irrigationEventId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateIrrigationEventMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateIrrigationEvent>>
>;
export type UpdateIrrigationEventMutationBody = IrrigationEventUpdate;
export type UpdateIrrigationEventMutationError =
	| UpdateIrrigationEvent400
	| UpdateIrrigationEvent404
	| UpdateIrrigationEvent409
	| UpdateIrrigationEvent500;
export type UpdateIrrigationEventMutationVariables = {
	irrigationEventId: string;
	data: IrrigationEventUpdate;
};

/**
 * @summary Update an existing irrigation event
 */
export const useUpdateIrrigationEvent = <
	TError =
		| UpdateIrrigationEvent400
		| UpdateIrrigationEvent404
		| UpdateIrrigationEvent409
		| UpdateIrrigationEvent500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateIrrigationEvent>>,
			TError,
			UpdateIrrigationEventMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateIrrigationEvent>>,
	TError,
	UpdateIrrigationEventMutationVariables,
	TContext
> => {
	return useMutation(
		getUpdateIrrigationEventMutationOptions(options),
		queryClient,
	);
};
export const getDeleteIrrigationEventUrl = (
	irrigationEventId: string,
	params: DeleteIrrigationEventParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/irrigation-events/${irrigationEventId}?${stringifiedParams}`
		: `/irrigation-events/${irrigationEventId}`;
};

/**
 * @summary Delete a one-time irrigation event
 */
export const deleteIrrigationEvent = async (
	irrigationEventId: string,
	params: DeleteIrrigationEventParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationEventResponse> => {
	return customFetch<IrrigationEventResponse>(
		getDeleteIrrigationEventUrl(irrigationEventId, params),
		{
			...options,
			method: "DELETE",
		},
	);
};

export const getDeleteIrrigationEventMutationKey = () =>
	["deleteIrrigationEvent"] as const;

export const getDeleteIrrigationEventMutationOptions = <
	TError =
		| DeleteIrrigationEvent400
		| DeleteIrrigationEvent404
		| DeleteIrrigationEvent409
		| DeleteIrrigationEvent500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteIrrigationEvent>>,
		TError,
		DeleteIrrigationEventMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteIrrigationEvent>>,
	TError,
	DeleteIrrigationEventMutationVariables,
	TContext
> => {
	const mutationKey = getDeleteIrrigationEventMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteIrrigationEvent>>,
		DeleteIrrigationEventMutationVariables
	> = (props) => {
		const { irrigationEventId, params } = props ?? {};

		return deleteIrrigationEvent(irrigationEventId, params, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteIrrigationEventMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteIrrigationEvent>>
>;

export type DeleteIrrigationEventMutationError =
	| DeleteIrrigationEvent400
	| DeleteIrrigationEvent404
	| DeleteIrrigationEvent409
	| DeleteIrrigationEvent500;
export type DeleteIrrigationEventMutationVariables = {
	irrigationEventId: string;
	params: DeleteIrrigationEventParams;
};

/**
 * @summary Delete a one-time irrigation event
 */
export const useDeleteIrrigationEvent = <
	TError =
		| DeleteIrrigationEvent400
		| DeleteIrrigationEvent404
		| DeleteIrrigationEvent409
		| DeleteIrrigationEvent500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteIrrigationEvent>>,
			TError,
			DeleteIrrigationEventMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteIrrigationEvent>>,
	TError,
	DeleteIrrigationEventMutationVariables,
	TContext
> => {
	return useMutation(
		getDeleteIrrigationEventMutationOptions(options),
		queryClient,
	);
};
export const getCreateOnDemandIrrigationEventUrl = () => {
	return `/irrigation-events/on-demand`;
};

/**
 * @summary Create a one-shot irrigation event and switch its zones' devices to schedule mode in one action
 */
export const createOnDemandIrrigationEvent = async (
	onDemandIrrigationEventCreateRequest: OnDemandIrrigationEventCreateRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<CreateOnDemandIrrigationEvent201> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<CreateOnDemandIrrigationEvent201>(
		getCreateOnDemandIrrigationEventUrl(),
		{
			...options,
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(onDemandIrrigationEventCreateRequest),
		},
	);
};

export const getCreateOnDemandIrrigationEventMutationKey = () =>
	["createOnDemandIrrigationEvent"] as const;

export const getCreateOnDemandIrrigationEventMutationOptions = <
	TError =
		| CreateOnDemandIrrigationEvent400
		| OnDemandIrrigationRejection
		| CreateOnDemandIrrigationEvent500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createOnDemandIrrigationEvent>>,
		TError,
		CreateOnDemandIrrigationEventMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createOnDemandIrrigationEvent>>,
	TError,
	CreateOnDemandIrrigationEventMutationVariables,
	TContext
> => {
	const mutationKey = getCreateOnDemandIrrigationEventMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createOnDemandIrrigationEvent>>,
		CreateOnDemandIrrigationEventMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return createOnDemandIrrigationEvent(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateOnDemandIrrigationEventMutationResult = NonNullable<
	Awaited<ReturnType<typeof createOnDemandIrrigationEvent>>
>;
export type CreateOnDemandIrrigationEventMutationBody =
	OnDemandIrrigationEventCreateRequest;
export type CreateOnDemandIrrigationEventMutationError =
	| CreateOnDemandIrrigationEvent400
	| OnDemandIrrigationRejection
	| CreateOnDemandIrrigationEvent500;
export type CreateOnDemandIrrigationEventMutationVariables = {
	data: OnDemandIrrigationEventCreateRequest;
};

/**
 * @summary Create a one-shot irrigation event and switch its zones' devices to schedule mode in one action
 */
export const useCreateOnDemandIrrigationEvent = <
	TError =
		| CreateOnDemandIrrigationEvent400
		| OnDemandIrrigationRejection
		| CreateOnDemandIrrigationEvent500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createOnDemandIrrigationEvent>>,
			TError,
			CreateOnDemandIrrigationEventMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createOnDemandIrrigationEvent>>,
	TError,
	CreateOnDemandIrrigationEventMutationVariables,
	TContext
> => {
	return useMutation(
		getCreateOnDemandIrrigationEventMutationOptions(options),
		queryClient,
	);
};
export const getStopIrrigationEventUrl = (irrigationEventId: string) => {
	return `/irrigation-events/stop/${irrigationEventId}`;
};

/**
 * Shortens a started irrigation so it ends three minutes ago, or deletes it outright when it has not started or when shortening it would leave less than the minimum duration; `deleted` on the returned irrigation says which happened. The zone's offset and watering percentage are accounted for. A repeating irrigation, one belonging to a set, one on more than a single zone, and one that has already ended are rejected with a 409.
 * @summary Stop a single-occurrence irrigation, shortening it if it has started and deleting it if it has not
 */
export const stopIrrigationEvent = async (
	irrigationEventId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<IrrigationEventResponse> => {
	return customFetch<IrrigationEventResponse>(
		getStopIrrigationEventUrl(irrigationEventId),
		{
			...options,
			method: "POST",
		},
	);
};

export const getStopIrrigationEventMutationKey = () =>
	["stopIrrigationEvent"] as const;

export const getStopIrrigationEventMutationOptions = <
	TError =
		| StopIrrigationEvent400
		| StopIrrigationEvent404
		| StopIrrigationRejection
		| StopIrrigationEvent500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof stopIrrigationEvent>>,
		TError,
		StopIrrigationEventMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof stopIrrigationEvent>>,
	TError,
	StopIrrigationEventMutationVariables,
	TContext
> => {
	const mutationKey = getStopIrrigationEventMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof stopIrrigationEvent>>,
		StopIrrigationEventMutationVariables
	> = (props) => {
		const { irrigationEventId } = props ?? {};

		return stopIrrigationEvent(irrigationEventId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type StopIrrigationEventMutationResult = NonNullable<
	Awaited<ReturnType<typeof stopIrrigationEvent>>
>;

export type StopIrrigationEventMutationError =
	| StopIrrigationEvent400
	| StopIrrigationEvent404
	| StopIrrigationRejection
	| StopIrrigationEvent500;
export type StopIrrigationEventMutationVariables = {
	irrigationEventId: string;
};

/**
 * @summary Stop a single-occurrence irrigation, shortening it if it has started and deleting it if it has not
 */
export const useStopIrrigationEvent = <
	TError =
		| StopIrrigationEvent400
		| StopIrrigationEvent404
		| StopIrrigationRejection
		| StopIrrigationEvent500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof stopIrrigationEvent>>,
			TError,
			StopIrrigationEventMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof stopIrrigationEvent>>,
	TError,
	StopIrrigationEventMutationVariables,
	TContext
> => {
	return useMutation(
		getStopIrrigationEventMutationOptions(options),
		queryClient,
	);
};
